module.exports = __webpack_public_path__ + "static/media/ana.cc5066c3.jpeg";